import throttle from 'lodash.throttle';
import { isCordova } from '../utils/isCordova';
import screenOrientationController from './screenOrientationController';
import SignaturePopup from '../components/popups/signaturePopup/SignaturePopup';
import SignatureHorizontalPopup from '../components/popups/signatureHorizontalPopup/SignatureHorizontalPopup';

class SignaturePopupController {
	getSignatureComponent = () => {
		if (isCordova() && !screenOrientationController.isTablet()) {
			return SignatureHorizontalPopup;
		}
		return SignaturePopup;
	};

	show = throttle((onFinish) => {
		const SignatureComponent = this.getSignatureComponent();
		window.popupController.show(SignatureComponent, { onFinish: this._handleComplete(onFinish) });
	}, 500, { leading: true, trailing: false });

	_handleComplete = (onFinish) => {
		return (img) => {
			const SignatureComponent = this.getSignatureComponent();
			window.popupController.hide(SignatureComponent);
			if (onFinish) {
				onFinish(img);
			}
		};
	};
}

export const signaturePopupController = new SignaturePopupController();